import { flow } from 'fp-ts/function';
import { compact, join } from 'lodash/fp';
import { ImageResizeMode } from '@mews/enums';

type PixelRatioValue = 1 | 1.5 | 2 | 4;

export interface ImageUrlDescription {
    pixelRatio: number;
    imageUrl: string;
}

export interface UrlParameters {
    mode?: ImageResizeMode;
    width?: number;
    height?: number;
    quality?: string | number;
    hashVersion?: string;
    pixelRatios?: PixelRatioValue[];
}

function imageUrl(
    imageId: string,
    baseUrl: string,
    { mode, quality, hashVersion, width, height }: UrlParameters = {}
): string {
    if (!imageId || !baseUrl) {
        throw new Error('imageId and baseUrl are required');
    }

    if (mode && !(mode in ImageResizeMode)) {
        throw new Error(`Image resize 'mode' is of an invalid value: '${mode.toString()}'`);
    }

    const baseImageUrl = `${baseUrl}/media/image/${imageId}?`;
    const baseParams = [
        mode && `mode=${mode}`,
        quality && `quality=${quality}`,
        hashVersion && `v=${hashVersion}`,
        width && `width=${width}`,
        height && `height=${height}`,
    ];
    const paramString = makeParamString(baseParams);

    return `${baseImageUrl}${paramString}`;
}

const makeParamString = flow(compact, join('&'));

export default {
    imageUrl,
};
